import React from 'react';

const NotFoundPage: React.FC = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-6 py-12">
            <div className="max-w-md w-full bg-white rounded-[32px] shadow-2xl shadow-emerald-100/50 p-8 text-center border border-white">
                <div className="mb-8 relative">
                    <img
                        src="/images/not_found.png"
                        alt="404 Not Found"
                        className="w-full h-auto rounded-2xl"
                    />
                </div>

                <h1 className="text-3xl font-black text-gray-900 mb-3 tracking-tight">
                    페이지를 찾을 수 없습니다
                </h1>

                <p className="text-gray-500 font-bold mb-8 leading-relaxed">
                    요청하신 주소가 올바르지 않거나<br />
                    이동되었을 수 있습니다.
                </p>

                <button
                    onClick={() => window.location.href = '/'}
                    className="w-full h-14 bg-emerald-500 hover:bg-emerald-600 text-white rounded-2xl font-black shadow-lg shadow-emerald-200 transition-all active:scale-[0.98] flex items-center justify-center gap-2"
                >
                    홈으로 돌아가기
                </button>
            </div>

            <p className="mt-8 text-gray-400 font-bold text-sm tracking-wide">
                OAS MARKET
            </p>
        </div>
    );
};

export default NotFoundPage;
